import { Injectable } from '@angular/core'

import { BehaviorSubject } from 'rxjs'
import { debounceTime, filter } from 'rxjs/operators'

@Injectable({
	providedIn: 'root',
})
export class WrapperDialogState {
	readonly exitButton = new BehaviorSubject<boolean>(false)
	readonly exitButton$ = this.exitButton.asObservable()
	readonly isScrollBottom = new BehaviorSubject<boolean>(false)
	readonly isScrollBottom$ = this.isScrollBottom.asObservable().pipe(
		filter((isScrollBottom) => isScrollBottom),
		debounceTime(100)
	)
	readonly isScrollTop = new BehaviorSubject<boolean>(false)
	readonly isScrollTop$ = this.isScrollTop.asObservable()
	readonly isScrollable = new BehaviorSubject<boolean>(false)
	readonly isScrollable$ = this.isScrollable.asObservable()

	enableExitButton(): void {
		this.exitButton.next(false)
	}

	disableExitButton(): void {
		this.exitButton.next(true)
	}
}
